module.exports = __webpack_public_path__ + "img/message-center.c24eaac3.svg";